import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CouponState } from '@store/reducers';

export const selectCouponState = createFeatureSelector<CouponState>('coupon');

export const selectCouponLoading = createSelector(
  selectCouponState,
  (state: CouponState) => state.loading
);

export const selectCoupon = createSelector(
  selectCouponState,
  (state: CouponState) => state.coupon
);

export const selectCouponList = createSelector(
  selectCouponState,
  (state: CouponState) => state.couponList
);

export const selectCouponError = createSelector(
  selectCouponState,
  (state: CouponState) => state.error
);

export const selectAppliedCoupon = createSelector(
  selectCouponState,
  (state: CouponState) => state.appliedCoupon
);
